import { render, staticRenderFns } from "./IdentificationTypeSelector.vue?vue&type=template&id=0296e316&"
import script from "./IdentificationTypeSelector.vue?vue&type=script&lang=js&"
export * from "./IdentificationTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports